function initMegaMenu() {
  let lastScrollY = window.scrollY;
  let scrollingTimeout;

  // Ẩn menu khi trang vừa tải xong
  document.querySelectorAll(".mega-menu__content").forEach(menu => {
    menu.style.display = "none";
  });

  window.addEventListener("scroll", function () {
    if (Math.abs(window.scrollY - lastScrollY) > 10) {
      document.body.classList.add("scrolling");

      // Nếu dropdown đang mở, tắt nó đi
      document.querySelectorAll(".mega-menu.show").forEach(menu => {
        menu.classList.remove("show");
        let content = menu.querySelector('.mega-menu__content');
        if (content) content.style.display = "none";
      });

      clearTimeout(scrollingTimeout);
      scrollingTimeout = setTimeout(() => {
        document.body.classList.remove("scrolling");
      }, 300);
    }

    lastScrollY = window.scrollY;
  });

  // Gán sự kiện hover cho các mega menu items sau khi DOM đã sẵn sàng
  document.querySelectorAll('.mega-menu').forEach(menu => {
    let timeout;

    menu.addEventListener('mouseenter', () => {
      clearTimeout(timeout);
      menu.classList.add('show');
      let content = menu.querySelector('.mega-menu__content');
      if (content) content.style.display = "block"; // Hiển thị menu khi hover
    });

    menu.addEventListener('mouseleave', () => {
      timeout = setTimeout(() => {
        menu.classList.remove('show');
        let content = menu.querySelector('.mega-menu__content');
        if (content) content.style.display = "none"; // Ẩn menu khi không hover nữa
      }, 200);
    });

    let content = menu.querySelector('.mega-menu__content');
    if (content) {
      content.addEventListener('mouseenter', () => {
        clearTimeout(timeout);
      });

      content.addEventListener('mouseleave', () => {
        timeout = setTimeout(() => {
          menu.classList.remove('show');
          content.style.display = "none";
        }, 200);
      });
    }
  });
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initMegaMenu);
} else {
  initMegaMenu();
}
